import { render, staticRenderFns } from "./OrganisationUserForm.vue?vue&type=template&id=2a4262f5&scoped=true"
import script from "./OrganisationUserForm.vue?vue&type=script&lang=js"
export * from "./OrganisationUserForm.vue?vue&type=script&lang=js"
import style0 from "./OrganisationUserForm.vue?vue&type=style&index=0&id=2a4262f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4262f5",
  null
  
)

export default component.exports